import React from 'react';
import styled from '@emotion/styled';
import Container from '@mui/material/Container';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FooterLink } from './FooterLink';
import { IFooterLink } from '@interfaces';
import { LocaleConfigContext } from '../../../../contexts/locale-config/locale-config';

const StyledFooterList = styled.ul`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 0;
    list-style: none;
    margin: 0;
    flex-wrap: wrap;
    line-height: 1.4;

    ${(props) => props.theme.media.mdAndUp} {
        justify-content: flex-start;
    }

    li {
        padding-left: 5px;
        padding-right: 5px;

        &:first-child {
            padding-left: 0;
        }
        &:last-child {
            padding-right: 0;
        }
    }
`;

const StyledNav = styled.nav`
    display: flex;
    justify-content: center;

    ${(props) => props.theme.media.mdAndUp} {
        justify-content: flex-end;
    }
`;

interface IProps {
    className?: string;
    list: IFooterLink[];
}

export const FooterBottom = ({ list, className }: IProps) => {
    const theme = useTheme();
    const isMediaDesktop = useMediaQuery(theme.breakpoints.up('lg'));
    const localeConfig = React.useContext(LocaleConfigContext);
    const domainEntries = Object.entries(localeConfig.domainMap);

    const footerLinks: IFooterLink[] = domainEntries
        .filter(([key, domain]) => domain !== localeConfig.url)
        .map(([key, domain]) => ({
            targetUrl: `https://www.${domain}`,
            title: domain,
        }));

    return (
        <div className={className || ''}>
            <Container disableGutters={isMediaDesktop} className="container">
                <div className="col-xs-12 col-sm-6 col-md-6">
                    <nav>
                        <StyledFooterList>
                            {list.map((e, key) => (
                                <li key={key}>
                                    <FooterLink {...e} />
                                </li>
                            ))}
                        </StyledFooterList>
                    </nav>
                </div>
                <div className="col-xs-12 col-sm-6 col-md-6">
                    <StyledNav>
                        <StyledFooterList>
                            {footerLinks.map((e, key) => (
                                <li key={key}>
                                    <FooterLink {...e} />
                                </li>
                            ))}
                        </StyledFooterList>
                    </StyledNav>
                </div>
            </Container>
        </div>
    );
};
